import { useContext } from 'react';
import { ApplicationContext } from '../contexts/ApplicationContext';

export function useApplication() {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error('useApplication must be used within an ApplicationProvider');
  }
  return context;
}